import { render, staticRenderFns } from "./DataProcessing.vue?vue&type=template&id=068e1784&"
import script from "./DataProcessing.vue?vue&type=script&lang=js&"
export * from "./DataProcessing.vue?vue&type=script&lang=js&"
import style0 from "./DataProcessing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports